import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Inject } from "@angular/core";
import { Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-targetting-engine-status',
  templateUrl: './targetting-engine-status.component.html',
  styleUrls: ['./targetting-engine-status.component.scss']
})
export class TargettingEngineStatusComponent implements OnInit {
  public isShowSpinner = false;
  public isShowGreen = false;
  public isBackToTopShowBtn = false;
  public resObj: any;
  public pingRes: any;
  public mergeStatusList: any = [];
  public knowledgeBases: any;
  public viewResponse: any = [];
  public viewData: string = '';
  public viewData1: string = '';
  public lastPingedAt: string = '';
  public lastPingStatus: string = '';
  public targetgetEngineVersion = '';
  public originalList: any = [];
  public originalKeysList: any = [];
  public targetEngineRuleId = '';
  public globalManagedRes: any;
  public globalServices: any = [];
  targetEngineServiceResponseObj: any
  idsFdspEngineServiceResponseObj: any
  ptsEngineServiceResponseObj: any
  fdspEngineServiceResponseObj: any
  isEnableService = false;
  blackout = false
  showTEList: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document, private service: ApifirstService, private router: Router) {

  }

  ngOnInit(): void {
    this.service.serviceNameListservice.subscribe((data) => {
      this.globalServices = data
      for (let obj of this.globalServices){
        if (obj.serviceName=="Target Engine Service"){
          this.targetEngineServiceResponseObj=obj;
        }
      }
     })
    this.getApiCall();
    this.getTargetEngineVersion();
  }
  showSpinner(id: string) {
    this.service.ruleId.next(id);
    this.service.getRulesOnId(id).subscribe(
      (data1) => {
        this.isShowSpinner = false;
        this.isShowGreen = true;
        this.service.ruleId.subscribe((data) => {
          this.targetEngineRuleId = data;
        })
        this.viewData = data1[0];
        let re = /\;/gi;
        //this.viewData = this.viewData.replace(re,'<br>');
        this.viewData = this.viewData.split(' ').join('<br>');
        this.viewData1 = data1[1];
        this.viewData1 = this.viewData1.split(' ').join('<br>');
        const newWindow = window.open('', '_blank', 'width=700,height=700')?.document.write('<html><head><title>diagnostic/admin/viewOnlineRule.do?id=' + this.targetEngineRuleId + '&version=2</title></head><body>' + this.viewData + this.viewData1 + '</body></html>');

      })
  }

  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }

  getApiCall() {
    this.service.getGlobalManagedServicesDetails(this.targetEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes = data;
      
      if (!this.globalManagedRes) {
        this.isEnableService = true;
      } else {
        this.isEnableService = false;
      } 
    

      if (this.isEnableService) {
        this.service.getTargetEngineStatusDetails().subscribe(
          (data1) => {
            this.resObj = data1;
            this.knowledgeBases = this.resObj.knowledgeBases;
            for (let knowledgeBase in this.knowledgeBases) {
              this.mergeStatusList.push({
                "header": knowledgeBase,
                "rules": this.knowledgeBases[knowledgeBase].rules
              })
            }
            this.showTEList = true;
            console.log('Merged LIST:-------', this.mergeStatusList);
            this.getApiCallForPing();
          })
      } else {
        this.service.selectedGlobalServices.next('Target Engine Service')
        this.router.navigate(['/globalServiceEnabled']);

      }
    });
  }

  getApiCallForPing() {
    this.isShowSpinner = true;
    this.service.getPingStatusDetails().subscribe(
      (data1) => {
        let pingArr = [];
        this.isShowSpinner = false;
        this.isShowGreen = true;
        this.pingRes = data1;
        let pingStatus = '';
        for (let ping in data1) {
          pingStatus = data1[ping];
          pingArr.push(pingStatus)
        }
        this.lastPingedAt = pingArr[0];
        this.lastPingStatus = pingArr[1];

      })
  }
  getTargetEngineVersion() {
    this.service.getTargetEngineVersion().subscribe(
      (data1) => {
        let version: any;
        this.targetgetEngineVersion = data1.targetingEngineVersion;

      })
  }

}
